/**
 * Frete Expresso (entrega local SP Capital) + Retirada em loja.
 * Espelha as zonas Admin · Entrega local (docs/frete-expresso-entrega-local.md).
 * A Ajax Cart (/cart/shipping_rates.json) não devolve Local Delivery nem pickup
 * de forma confiável; na PDP/sacola usamos match por CEP + merge com carriers Frenet.
 *
 * PAC/SEDEX/Jadlog: exatamente o preço da Frenet. O tema não pinta Grátis em
 * carrier que o checkout não vai zerar (ADR-089). Exceção: Frete Expresso em SP
 * capital, só se for mais barato que as rates pagas da Frenet e o carrinho
 * passar do threshold. Retirada em loja continua grátis (é grátis no checkout).
 */
(function (global) {
  'use strict';

  var FREE_SHIP_THRESHOLD_CENTS = 150000;

  var ZONES = [
    { price: 15, prefixes: ['050', '054', '055', '056'] },
    {
      price: 25,
      prefixes: ['010', '011', '012', '013', '014', '015', '049', '051', '053'],
    },
    {
      price: 30,
      prefixes: [
        '020',
        '021',
        '024',
        '025',
        '026',
        '027',
        '028',
        '029',
        '030',
        '040',
        '041',
        '042',
        '043',
        '044',
        '045',
        '046',
        '047',
      ],
    },
    {
      price: 35,
      prefixes: [
        '022',
        '023',
        '031',
        '033',
        '034',
        '035',
        '036',
        '037',
        '038',
        '039',
        '057',
        '058',
        '059',
      ],
    },
  ];

  /**
   * SP capital: prefixos 010–059 (cidade de São Paulo).
   * @param {string} digits
   * @returns {boolean}
   */
  function isSpCapital(digits) {
    var cep = String(digits || '').replace(/\D/g, '');
    if (cep.length !== 8) return false;
    var n = Number(cep.slice(0, 3));
    return Number.isFinite(n) && n >= 10 && n <= 59;
  }

  /**
   * @param {object} rate
   * @returns {object}
   */
  function cloneRate(rate) {
    var free = {};
    for (var key in rate) {
      if (Object.prototype.hasOwnProperty.call(rate, key)) free[key] = rate[key];
    }
    return free;
  }

  /**
   * @param {object} rate
   * @returns {number}
   */
  function ratePriceNumber(rate) {
    var n = Number(rate && rate.price);
    return Number.isFinite(n) ? n : NaN;
  }

  /**
   * @param {object} rate
   * @returns {boolean}
   */
  function isPickupRate(rate) {
    var code = String((rate && rate.code) || '');
    if (code === 'gm-retirada' || code.indexOf('pick') !== -1) return true;
    return isPickupLikeName((rate && (rate.presentment_name || rate.name)) || '');
  }

  /**
   * Entrega local / Frete Expresso (planilha ou Shopify Local Delivery).
   * @param {object} rate
   * @returns {boolean}
   */
  function isExpressoRate(rate) {
    var code = String((rate && rate.code) || '');
    if (code.indexOf('gm-frete-expresso') === 0) return true;
    if (code.indexOf('gm-local-delivery') !== -1) return true;
    return isExpressoLikeName((rate && (rate.presentment_name || rate.name)) || '');
  }

  /**
   * Não pinta Grátis em PAC/SEDEX/Jadlog. Só o Expresso de SP pode ser zerado,
   * e só se for estritamente mais barato que todas as rates pagas da Frenet.
   * Se a Frenet já zerou alguma entrega, não inventa Expresso grátis.
   *
   * @param {object[]} rates
   * @param {number|null|undefined} cartTotalCents
   * @param {number|null|undefined} thresholdCents
   * @returns {object[]}
   */
  function applyCheapestFree(rates, cartTotalCents, thresholdCents) {
    var list = Array.isArray(rates) ? rates.slice() : [];
    var thr =
      thresholdCents == null || !Number.isFinite(Number(thresholdCents))
        ? FREE_SHIP_THRESHOLD_CENTS
        : Number(thresholdCents);
    var total = Number(cartTotalCents);
    if (!Number.isFinite(total) || total < thr || !list.length) return list;

    var expressoIdx = -1;
    var expressoPrice = Infinity;
    var cheapestFrenet = Infinity;
    var frenetPaidCount = 0;
    var frenetFreeCount = 0;

    for (var i = 0; i < list.length; i++) {
      var p = ratePriceNumber(list[i]);
      if (!Number.isFinite(p)) continue;
      if (isPickupRate(list[i])) continue;
      if (isExpressoRate(list[i])) {
        if (expressoIdx < 0 || p < expressoPrice) {
          expressoIdx = i;
          expressoPrice = p;
        }
        continue;
      }
      if (p <= 0) frenetFreeCount += 1;
      else {
        frenetPaidCount += 1;
        if (p < cheapestFrenet) cheapestFrenet = p;
      }
    }

    if (frenetFreeCount > 0) return list;
    if (expressoIdx < 0) return list;
    if (!Number.isFinite(expressoPrice) || expressoPrice <= 0) return list;
    if (frenetPaidCount === 0) return list;
    if (!(expressoPrice < cheapestFrenet)) return list;

    var free = cloneRate(list[expressoIdx]);
    free.gm_compare_at_price = String(expressoPrice.toFixed(2));
    free.price = '0.00';
    free.gm_free_shipping = true;
    list[expressoIdx] = free;
    return list;
  }

  /**
   * @param {string} digits CEP só dígitos (8)
   * @returns {{name:string,presentment_name:string,price:string,code:string,gm_eta:string,source:string}|null}
   */
  function pickupRate(digits) {
    if (!isSpCapital(digits)) return null;
    return {
      name: 'Retirada em loja',
      presentment_name: 'Retirada em loja',
      price: '0.00',
      code: 'gm-retirada',
      gm_eta: '(grátis)',
      source: 'gm-local-pickup',
    };
  }

  /**
   * Preço da planilha (sem aplicar threshold — isso fica em applyCheapestFree).
   * @param {string} digits CEP só dígitos (8)
   * @returns {{name:string,presentment_name:string,price:string,code:string,gm_eta:string,source:string}|null}
   */
  function match(digits) {
    var cep = String(digits || '').replace(/\D/g, '');
    if (cep.length !== 8) return null;
    var prefix = cep.slice(0, 3);
    for (var i = 0; i < ZONES.length; i++) {
      var zone = ZONES[i];
      if (zone.prefixes.indexOf(prefix) !== -1) {
        return {
          name: 'Frete Expresso',
          presentment_name: 'Frete Expresso',
          price: zone.price.toFixed(2),
          code: 'gm-frete-expresso-' + zone.price,
          gm_eta: '(entrega em até 24 horas após o processamento)',
          source: 'gm-local-delivery',
        };
      }
    }
    return null;
  }

  /**
   * @param {string} name
   * @returns {boolean}
   */
  function isExpressoLikeName(name) {
    var n = String(name || '').toLowerCase();
    return (
      n.indexOf('frete expresso') !== -1 ||
      n.indexOf('local delivery') !== -1 ||
      n.indexOf('entrega local') !== -1
    );
  }

  /**
   * @param {string} name
   * @returns {boolean}
   */
  function isPickupLikeName(name) {
    var n = String(name || '').toLowerCase();
    return (
      n.indexOf('retirada') !== -1 ||
      n.indexOf('pick up') !== -1 ||
      n.indexOf('pickup') !== -1 ||
      n.indexOf('local pickup') !== -1
    );
  }

  /**
   * Prefixa Retirada (SP) + Frete Expresso; remove duplicatas; mantém carriers Frenet
   * no preço da API. Expresso só fica grátis ≥ threshold se for mais barato que a Frenet.
   * @param {object[]} rates
   * @param {string} digits
   * @param {number|null|undefined} [cartTotalCents]
   * @param {number|null|undefined} [thresholdCents]
   * @param {{ preVenda?: boolean }} [options]
   * @returns {object[]}
   */
  function mergeRates(rates, digits, cartTotalCents, thresholdCents, options) {
    var list = Array.isArray(rates) ? rates.slice() : [];
    var preVenda = false;
    if (options && typeof options === 'object') {
      preVenda = Boolean(options.preVenda);
    }
    var pickup = pickupRate(digits);
    var local = match(digits);
    if (local && preVenda) {
      local.gm_eta = '(entrega em até 24 horas após o processamento)';
    }

    list = list.filter(function (rate) {
      var n = rate.presentment_name || rate.name || '';
      if (local && isExpressoLikeName(n)) return false;
      if (pickup && isPickupLikeName(n)) return false;
      return true;
    });

    if (local) list.unshift(local);
    if (pickup) list.unshift(pickup);
    return applyCheapestFree(list, cartTotalCents, thresholdCents);
  }

  /**
   * Compat: só zera Expresso, e só se applyCheapestFree tiver Frenet para comparar.
   * Lista de 1 carrier Frenet nunca é pintada de Grátis.
   * @param {object} rate
   * @param {number|null|undefined} cartTotalCents
   * @param {number|null|undefined} thresholdCents
   * @returns {object}
   */
  function applyFreeShipping(rate, cartTotalCents, thresholdCents) {
    if (!rate) return rate;
    var out = applyCheapestFree([rate], cartTotalCents, thresholdCents);
    return out[0] || rate;
  }

  var STORAGE_CEP = 'gm_cart_cep';
  var STORAGE_GEO = 'gm_cart_cep_geo';

  var UF_PROVINCE = {
    AC: 'Acre',
    AL: 'Alagoas',
    AP: 'Amapá',
    AM: 'Amazonas',
    BA: 'Bahia',
    CE: 'Ceará',
    DF: 'Distrito Federal',
    ES: 'Espírito Santo',
    GO: 'Goiás',
    MA: 'Maranhão',
    MT: 'Mato Grosso',
    MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais',
    PA: 'Pará',
    PB: 'Paraíba',
    PR: 'Paraná',
    PE: 'Pernambuco',
    PI: 'Piauí',
    RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte',
    RS: 'Rio Grande do Sul',
    RO: 'Rondônia',
    RR: 'Roraima',
    SC: 'Santa Catarina',
    SP: 'São Paulo',
    SE: 'Sergipe',
    TO: 'Tocantins',
  };

  /**
   * @param {string} value
   * @returns {string} 8 dígitos ou string curta
   */
  function normalizeCep(value) {
    return String(value || '')
      .replace(/\D/g, '')
      .slice(0, 8);
  }

  /**
   * @param {string} value
   * @returns {string}
   */
  function formatCep(value) {
    var digits = normalizeCep(value);
    if (digits.length > 5) return digits.slice(0, 5) + '-' + digits.slice(5);
    return digits;
  }

  /**
   * @returns {string} 8 dígitos ou ''
   */
  function readCep() {
    try {
      var digits = normalizeCep(
        global.sessionStorage && global.sessionStorage.getItem(STORAGE_CEP)
      );
      return digits.length === 8 ? digits : '';
    } catch (_) {
      return '';
    }
  }

  /**
   * @param {string} digits
   */
  function writeCep(digits) {
    var next = normalizeCep(digits);
    var prev = readCep();
    try {
      if (global.sessionStorage) {
        if (next.length === 8) global.sessionStorage.setItem(STORAGE_CEP, next);
        else global.sessionStorage.removeItem(STORAGE_CEP);
        if (next.length !== 8 || next !== prev) {
          global.sessionStorage.removeItem(STORAGE_GEO);
        }
      }
    } catch (_) {
      /* ignore */
    }
    if (typeof document !== 'undefined' && document.dispatchEvent) {
      document.dispatchEvent(
        new CustomEvent('gm:cep-change', { detail: { cep: next } })
      );
    }
  }

  /**
   * @returns {{ uf?: string, localidade?: string } | null}
   */
  function readCepGeo() {
    try {
      var raw =
        global.sessionStorage && global.sessionStorage.getItem(STORAGE_GEO);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (_) {
      return null;
    }
  }

  /**
   * @param {{ uf?: string, localidade?: string } | null} geo
   */
  function writeCepGeo(geo) {
    try {
      if (!global.sessionStorage) return;
      if (geo && (geo.uf || geo.localidade)) {
        global.sessionStorage.setItem(STORAGE_GEO, JSON.stringify(geo));
      } else {
        global.sessionStorage.removeItem(STORAGE_GEO);
      }
    } catch (_) {
      /* ignore */
    }
  }

  /**
   * Params oficiais de cart permalink para prefill do checkout (spec 0116).
   * @param {string} cep
   * @param {{ uf?: string, localidade?: string, city?: string } | null} [geo]
   * @returns {Record<string, string> | null}
   */
  function checkoutPrefillParams(cep, geo) {
    var digits = normalizeCep(cep);
    if (digits.length !== 8) return null;
    /** @type {Record<string, string>} */
    var params = {
      'checkout[shipping_address][zip]': formatCep(digits),
      'checkout[shipping_address][country]': 'Brazil',
    };
    var uf = geo && geo.uf ? String(geo.uf).toUpperCase() : '';
    var city = (geo && (geo.localidade || geo.city)) || '';
    if (uf) {
      params['checkout[shipping_address][province]'] = UF_PROVINCE[uf] || uf;
    }
    if (city) params['checkout[shipping_address][city]'] = String(city);
    return params;
  }

  /**
   * @param {string} cep
   * @param {{ uf?: string, localidade?: string } | null} [geo]
   * @returns {string}
   */
  function checkoutPrefillSearch(cep, geo) {
    var params = checkoutPrefillParams(cep, geo);
    if (!params) return '';
    var qs = new URLSearchParams();
    Object.keys(params).forEach(function (key) {
      qs.set(key, params[key]);
    });
    return qs.toString();
  }

  /**
   * @param {string} uf
   * @returns {string}
   */
  function provinceName(uf) {
    var code = String(uf || '').toUpperCase();
    return UF_PROVINCE[code] || code;
  }

  /**
   * Querystring da Ajax Cart (Frenet precisa de UF por extenso + cidade).
   * @param {string} cep
   * @param {{ uf?: string, localidade?: string, city?: string } | null} [geo]
   * @returns {URLSearchParams}
   */
  function shippingAddressParams(cep, geo) {
    var digits = normalizeCep(cep);
    var params = new URLSearchParams();
    params.set('shipping_address[zip]', digits);
    params.set('shipping_address[country]', 'Brazil');
    params.set('include_carrier_rates', 'true');
    var uf = geo && geo.uf ? String(geo.uf).toUpperCase() : '';
    var city = (geo && (geo.localidade || geo.city)) || '';
    if (uf) params.set('shipping_address[province]', provinceName(uf));
    if (city) params.set('shipping_address[city]', String(city));
    return params;
  }

  global.GMFreteExpresso = {
    match: match,
    mergeRates: mergeRates,
    pickupRate: pickupRate,
    isSpCapital: isSpCapital,
    applyFreeShipping: applyFreeShipping,
    applyCheapestFree: applyCheapestFree,
    zones: ZONES,
    FREE_SHIP_THRESHOLD_CENTS: FREE_SHIP_THRESHOLD_CENTS,
    STORAGE_CEP: STORAGE_CEP,
    formatCep: formatCep,
    normalizeCep: normalizeCep,
    readCep: readCep,
    writeCep: writeCep,
    readCepGeo: readCepGeo,
    writeCepGeo: writeCepGeo,
    checkoutPrefillParams: checkoutPrefillParams,
    checkoutPrefillSearch: checkoutPrefillSearch,
    provinceName: provinceName,
    shippingAddressParams: shippingAddressParams,
  };
})(typeof window !== 'undefined' ? window : globalThis);
